import { createVanIconComponent } from "./van"

const ThumbCircleOutlined = createVanIconComponent("thumb-circle-o")
export default ThumbCircleOutlined
